import { MDBCol } from "mdb-react-ui-kit";
import Btn from "@/components/common/Btn";
import React, { FC, ReactNode } from "react";
import styles from "../../../styles/booking/booking.module.scss";
import { EButtonBooking } from "../../../models/common/enums";
import { TAccountButtonType } from "../../../models/account";

const ContentSectionLayout: FC<{
    children: ReactNode;
    title: string;
    buttonId: TAccountButtonType;
    buttonBack: string;
    onClick: (buttonId: TAccountButtonType) => void;
}> = ({ children, title, onClick, buttonId, buttonBack }) => {
    return buttonId === EButtonBooking.YOURBOOKING ? (
        <MDBCol
            size={12}
            lg={10}
            xl={7}
            className={`${styles.dxColumn} py-sm-4 px-md-4`}
        >
            <p className={`${styles.title} py-3 py-lg-0`}>{title}</p>
            {children}
        </MDBCol>
    ) : (
        <MDBCol
            size={12}
            lg={10}
            xl={7}
            className={`${styles.dxColumn} py-sm-4 px-md-4`}
        >
            <div className={styles.topBar}>
                <p className={`${styles.title} py-3 py-lg-0`}>{title}</p>
                <Btn
                    className={styles.backButton}
                    onClick={() => onClick(EButtonBooking.YOURBOOKING)}
                >
                    {buttonBack}
                </Btn>
            </div>
            {children}
        </MDBCol>
    );
};

export default ContentSectionLayout;
